import React from 'react';
import ReactDOM from 'react-dom';
import RaisedButton from 'material-ui/RaisedButton';
import {Alert} from "react-bootstrap";
import {DomainAncestor} from "core/common/domain/DomainAncestor";
import {createForm} from "core/form/createForm";
import {observer} from "mobx-react";
import {FormProps} from "core/form/formUtils";
import {DATATYPE, default as MdField} from "core/metamodel/mdField";
import {MdTextField} from "core/components/fields/fields";
import securityService from 'core/security/securityService';
import {observable, action} from "mobx";
import {Validate} from "core/form/validate";
import {PARAMKEY} from "core/security/securityDomain";
import {FIELDDEFSIZE} from "core/form/form";


export class LoginObject extends DomainAncestor {
  @observable username: string;
  @observable password: string;
  @observable loginText: string;

  constructor(json: any) {
    super(json);
  }
}




@createForm({
  formName: 'LoginObjecForm',
  fields: [{
    name: 'username',
    usePlaceholder: true, size: FIELDDEFSIZE.big,
    mdField: new MdField({label: 'Username', dataType: DATATYPE.STRING })
  }, {
    name: 'password',
    usePlaceholder: true, size: FIELDDEFSIZE.big,
    mdField: new MdField({label: 'Password', dataType: DATATYPE.STRING })
  }]
}, () => <noscript/>)
@observer
export class LoginObjectForm extends React.Component<FormProps<LoginObject, LoginObject>, undefined> {

  private usernameFieldRef: any;

  @action onSubmit = (e) => {
    console.log('form submited');
    e.preventDefault();

    let {dataObject, formName} = this.props;
    let form = dataObject.getForm(formName);

    if (!form.validateForm(dataObject, [])) {
      return;
    }

    this.props.onSubmit(dataObject)
      .catch((err) => {
        console.log('login error: %0', err);
        dataObject.$errors = [{message: "Bad username or password"}];
        dataObject.username = null;
        dataObject.password = null;
        dataObject.tenantId = null;

        dataObject.getForm(formName).updateFieldsPropValue(dataObject, "username", "password");

        let usernameFieldNode: Element = ReactDOM.findDOMNode(this.usernameFieldRef);
        if (usernameFieldNode) {
          usernameFieldNode.getElementsByTagName("input")[0].focus();
        }
      });
  };

  @action onChangeUsername = (e) => {
    let {dataObject, formName} = this.props;

    let form = dataObject.getForm(formName);
    form.getField("username").props.onChange(e);

    securityService.getLastTenantId(dataObject.username)
      .then((tenantId: number) => {
        return (tenantId) ? securityService.getTenantParamFromServer(tenantId, PARAMKEY.GDPR_LOGIN_TEXT) : Promise.resolve(null);
      })
      .then(action("tenantText-action", text => {
        dataObject.loginText = text as string;
      }));
  };


  usernameFieldRefHandler = comp => this.usernameFieldRef = comp;


  render() {
    const {dataObject, rootObject, index, entities, formName} = this.props;
    let {username, password} = dataObject.getFormFields(formName);

    return (
      <form onSubmit={this.onSubmit} autoComplete="off" >
        <div className="container-fluid" style={{marginTop: 40}}>

          { (dataObject.$errors && dataObject.$errors.length) ? (
            <div className="row">
              <div className="col-xs-offset-1 col-xs-10">
                <Alert bsStyle='danger'>
                  {dataObject.$errors.map(e => e.message)}
                </Alert>
              </div>
            </div>
          ) : null}

          <div className="row">
            <div className="col-xs-offset-1 col-xs-10">
              <h4>Please login</h4></div>
          </div>

          <div className="row">
            <div className="col-xs-offset-1 col-xs-10" style={{display:'flex'}}>
              <MdTextField {...username.props} ref={this.usernameFieldRefHandler}
                         onChange={this.onChangeUsername} autoFocus autoComplete="new-password" tabIndex="1" style={{maxWidth:200}} autocomplete="off" />
              <Validate field={username} value={username.props.value}/>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-offset-1 col-xs-10">
              <MdTextField {...password.props} type="password" autoComplete="new-password" tabIndex="3" style={{maxWidth:200}} autocomplete="off"/>
              <Validate field={password} value={password.props.value}/>
            </div>
          </div>
          <div className="row" style={{marginTop:20}}>
            <div className="col-xs-offset-1 col-xs-10">
              <RaisedButton type="submit"  label="Login" disabled={!dataObject.password || !dataObject.username} secondary={true} tabIndex={4}/>
            </div>
          </div>

          <div className="row" style={{marginTop:40}}>
            <div className="col-xs-offset-1 col-xs-10">
              <div dangerouslySetInnerHTML={{__html: dataObject.loginText}}/>
            </div>
          </div>

        </div>

      </form>

    );
  }
}



// WEBPACK FOOTER //
// ./src/core/security/loginForm.tsx